import React from "react";
import *as F from "./Footer-style";


export default function FooterLinks() {
   return (
      <div>
         <F.FooterTitle>links</F.FooterTitle>
         <F.FooterLinkItems>
            <div>
               <F.FooterLinkItem>home</F.FooterLinkItem>
               <F.FooterLinkItem>about</F.FooterLinkItem>
               <F.FooterLinkItem>services</F.FooterLinkItem>
               <F.FooterLinkItem>projects</F.FooterLinkItem>
               <F.FooterLinkItem>contact us</F.FooterLinkItem>
            </div>
            <div>
               <F.FooterLinkItem>faq</F.FooterLinkItem>
               <F.FooterLinkItem>terms</F.FooterLinkItem>
               <F.FooterLinkItem>careers</F.FooterLinkItem>
            </div>
            <div>
               <F.FooterLinkItem>blog</F.FooterLinkItem>
               <F.FooterLinkItem>partners</F.FooterLinkItem>
               <F.FooterLinkItem>news</F.FooterLinkItem>
            </div>
         </F.FooterLinkItems>
      </div>
   )

}